"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiOrderFindQueryDto = void 0;
const key_value_1 = require("../../../../shared/types/key-value");
const swagger_1 = require("../../../../swagger-fake");
const class_validator_1 = require("class-validator");
const billing_core_order_contractor_role_enum_1 = require("../../../../billing-core/billing-core-order/types/enums/billing-core-order-contractor-role.enum");
const class_transformer_1 = require("class-transformer");
class BillingApiOrderFindQueryDto {}
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id контрагента участвующего в сделке",
  required: false,
  type: String,
  format: 'uuid'
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(), __metadata("design:type", Object)], BillingApiOrderFindQueryDto.prototype, "contractorId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Роль контрагента участвующего в сделке (только вместе с contractorId)",
  required: false,
  enum: billing_core_order_contractor_role_enum_1.BillingCoreOrderContractorRoleEnum
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsEnum)(billing_core_order_contractor_role_enum_1.BillingCoreOrderContractorRoleEnum), __metadata("design:type", String)], BillingApiOrderFindQueryDto.prototype, "role", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск по свойствам мета-данных",
  required: false,
  type: String,
  format: "json",
  example: "{\"meetingId\":\"202675c9-0700-4472-bb2e-a2d2c2b2c401\"}"
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Transform)(params => params ? JSON.parse(params.value) : null, {
  toClassOnly: true
}), (0, class_validator_1.ValidateNested)({
  each: true
}), (0, class_transformer_1.Type)(() => key_value_1.Metadata), __metadata("design:type", key_value_1.Metadata)], BillingApiOrderFindQueryDto.prototype, "meta", void 0);
exports.BillingApiOrderFindQueryDto = BillingApiOrderFindQueryDto;
